(() => {
  const partsFor = (formatter, epoch) => {
    const values = Object.fromEntries(formatter.formatToParts(new Date(epoch)).map(({ type, value }) => [type, value]));
    return { year: Number(values.year), month: Number(values.month), day: Number(values.day), hour: Number(values.hour) % 24, minute: Number(values.minute), second: Number(values.second) };
  };

  const nextReset = (formatter, now, hour, minute) => {
    const local = partsFor(formatter, now);
    const tomorrow = local.hour * 3600 + local.minute * 60 + local.second >= hour * 3600 + minute * 60;
    const date = new Date(Date.UTC(local.year, local.month - 1, local.day + Number(tomorrow)));
    const desired = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), hour, minute);
    const offset = (epoch) => {
      const p = partsFor(formatter, epoch);
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(epoch / 1000) * 1000;
    };
    let target = desired - offset(desired);
    target = desired - offset(target);
    return target;
  };

  const start = (root) => {
    if (root.dataset.aevloStarted) return;
    const clock = root.querySelector('[data-aevlo-clock]');
    const hour = Number(root.dataset.resetHour);
    const minute = Number(root.dataset.resetMinute);
    if (!clock || hour < 0 || hour > 23 || minute < 0 || minute > 59) return;
    let formatter;
    try {
      formatter = new Intl.DateTimeFormat('en-GB', { timeZone: root.dataset.timeZone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    } catch { return; }
    root.dataset.aevloStarted = 'true';
    let target = nextReset(formatter, Date.now(), hour, minute);
    const tick = () => {
      if (!root.isConnected) { clearInterval(interval); return; }
      const now = Date.now();
      if (now >= target) target = nextReset(formatter, now, hour, minute);
      const remaining = Math.max(0, Math.ceil((target - now) / 1000));
      const hours = String(Math.floor(remaining / 3600)).padStart(2, '0');
      const minutes = String(Math.floor(remaining % 3600 / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      clock.textContent = `${hours}:${minutes}:${seconds}`;
      clock.hidden = false;
    };
    const interval = setInterval(tick, 1000);
    tick();
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-aevlo-countdown]').forEach(start);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
